<template>
  <div class="cheapCard">
    <van-pull-refresh v-model="pullLoading" @refresh="onRefresh">
      <van-tabs v-model="active" @change="tabChange"  animated color='#FFD133'  sticky>
        <van-tab v-for="item in tabs" :title="item.title" :name="item.name" :key="item.id">
        </van-tab>
      </van-tabs>
      <!-- 优惠券列表 -->
      <section class="comunity-list-box" >
        <van-list v-model="loading" v-if="!isEmpty"
          :finished="finished" finished-text="没有更多了" 
          :error.sync="errorLoad" :immediate-check="immediateCheck" 
          error-text="请求失败，点击重新加载" @load="onReachBottom" :offset="100">
          <couponList @toSelf="goSelf" :ctype="criteria.status" :list.sync="list"></couponList>
        </van-list>
      </section>
      <emptyCoupon v-if="isEmpty" :message="noMsg"></emptyCoupon>
    </van-pull-refresh>
  </div>
</template>
<script>
import CouponList from '@/components/business/CouponList'
import EmptyCoupon from '@/components/business/EmptyCoupon'
import { getCoupon } from "@/api/shop";
import { openApp } from '@/utils'
export default {
  name : 'cheapcard',
  components:{
    CouponList,
    EmptyCoupon
  },
  data(){
    return{
      pullLoading : false,
      page: 0,
      total: 0,
      pageTotal: 0,
      tabs :[{ id: 0,title: "未使用"},{ id: 1,title: "已使用"},{ id: 2,title: "已过期"}],
      isEmpty: false,
      active:'',
      loading : false,
      finished: false,
      list:[],
      status : 0,
      criteria: {
        pageIndex: 0,  //当前页
        pageSize: 10,  //每页总数
        status : 0,
      },
      errorLoad :false,
      immediateCheck: true,
      noMsg:"您还没有优惠券"
    }
  },
  computed: {
    token () {
      return this.$store.getters.token || ''
    }
  },
  methods:{
    goSelf(i){
      var cop = this.list[i]
      if(cop.scopeOfUseType == 1 || cop.scopeOfUseType == 6 || cop.scopeOfUseType == 7 || cop.scopeOfUseType == 8) {
        this.$store.commit('SET_USER_BALANCE', { couponId: cop.privilegeId, coupon: cop, isUse: true })
        // this.$router.push({name: "selfrun"})
        this.$router.push({ name: 'copGoodslist', params: { copid: cop.privilegeId } })
      } else if(cop.scopeOfUseType == 5) {
        location.href = process.env.VUE_APP_APPRASISER_URL + 'order/category'
      } else {
        this.$dialog.confirm({
          title: '提示',
          message: '下载胖虎奢侈品APP使用优惠卷',
          confirmButtonText: '去下载'
        }).then(()=>{
          location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.gian.punkhoo'
        }).catch(()=>{})
      }
    },
    //下拉刷新
    onRefresh(){
      this.page = 1,
      setTimeout(()=>{
        this.getData(true)
      },300)
    },
    //点击切换
    tabChange (name, title) {
      this.page = 1
      this.pageTotal = 0
      this.criteria.status = name
      this.getData(true)
    },
    //上拉加载
    onReachBottom () {
      console.log('dang' + this.page)
      if(this.page > this.pageTotal){
        this.finished = true
      }
      this.page++
      setTimeout(()=>{
        this.getData()
      },1000)
    },
    getData(refresh){
      this.criteria.pageIndex = this.page
      this.criteria.userToken = this.token
      getCoupon(this.criteria).then((res) => {
        console.log(res)
        if(refresh){
          this.list = res.result ||  []
          this.pullLoading = false
        }else{
          this.list = [...this.list,...res.result]
        }
        console.log(this.list)
        this.total = res.total
        this.pageTotal = res.pageCount
        if (this.list.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        // 加载状态结束
        this.loading = false
      }).catch((err) => {
        this.errorLoad = true
      })
    }
  }
}
</script>
<style lang="less">
.cheapCard {
  width: 100%;
  height: 100%;
  .van-tab {
    width: 33.33333%;
    .van-ellipsis{
      text-align: center!important;
    }
  }
}
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
</style>